<template>
	<div class="body-container" id="h-box">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div class="main blog-landing" rel="main">

			<div class="page-header-options">
				<div class="page-header-breadcrumb">
					<div class="breadcrumb-nav breadcrumb-nav-composed">
						<ul class="nav-links">
							<li class="nav-link" @click="goHome">
								<a ></a>
							</li>
							<li class="nav-link" @click="toPage('/insight')">
								<a >Insight</a>
							</li>
							<li class="nav-link">
								<span>Blogs</span>
							</li>
						</ul>

					</div>
				</div>
			</div>

			<div class="page-header-background-image page-header-background-image-forced-height background-image-desktop2">
				<div class="background-image background-image-desktop"></div>
			</div>
			<div class="page-wrapper page-header headline-module__page-header headline-module__image-background">

				<div class="content">
					<h1 class="page-title">Blogs</h1>
					<h3 class="page-subtitle">Insights and commentary on global topics and regulatory developments for
						your business to help deliver <a>solutions for a connected world</a>.</h3>
				</div>
			</div>
			<div class="page-wrapper">
				<h2 class="header" data-bind="html: BlogsSubTitle">Featured</h2>
				<!-- ko if: blogTopics() && blogTopics().length > 0 -->
				<div class="filter-container">
					<div class="blog-topic-tabs">
						<div class="label">Filter by Topic</div>
						<div class="promo-content-category-switcher">
							<a class="switch default-cat" style="cursor: pointer;" v-for="(item,index) in FeaturedList">{{item}}</a>
						</div>
					</div>
				</div>
				<!-- /ko -->
			</div>
			<div class="featured-insights">
				<div class="featured-insights__collection">
					<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image" v-for="(item,index) in newsList">
						<a class="promo-content-link" >
							<div class="container-table">
								<div class="pcm-standard-background-image" :style="{backgroundImage: 'url('+ item.img +')'}">
								</div>
								<div class="container-row">
									<div class="content">
										<div class="content-headline">{{item.title}}</div>
										<div class="content-summary">{{item.remarks}}</div>
									</div>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
			<!-- ko if: blogsToShow().length == 0 -->
			<!-- /ko -->

		</div>
		<div class="global-footer">
		    <div class="footer-nav hide-print">
		            <ul class="utility-links">
		                        <li class="utility-link"><a >Disclaimers</a></li>
		                        <li class="utility-link"><a >Privacy &amp; Cookies Statement</a></li>
		                        <li class="utility-link"><a class="ot-sdk-show-settings" title="Manage Choices">Cookie Preferences</a></li>
		                        <li class="utility-link"><a >CCPA Privacy Disclosures</a></li>
		                        <li class="utility-link"><a >Contact Us</a></li>
		                        <li class="utility-link"><a >Media Contacts</a></li>
		                        <li class="utility-link"><a >Blogs</a></li>
		                        <li class="utility-link"><a >BM Online</a></li>
		            </ul>
		        
		    </div>
		    <div class="copyright">
				<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>    
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				headerMini: false,
				thresholdHeight: 100,
				FeaturedList:['Antitrust & Competition','Compliance & Investigations','Dispute Resolution','Employment & Compensation','Environment & Climate Change','Financial Institutions','Healthcare & Life Sciences','Tax','Technology, Media and Telecommunications','International Commercial & Trade','Supply Chains','Workforce Redesign'],
				newsList:[
					{
						title:'Global Sanctions and Export Controls Blog',
						img:require('../../assets/test/61.jpeg'),
						remarks:'Providing real-time news and updates on US and EU economic sanctions against key sanctioned countries.'
					},
					{
						title:'Blockchain',
						img:require('../../assets/test/62.jpeg'),
						remarks:'Providing insight on legal developments, regulatory matters, policy issues and business concerns surrounding blockchain regulation.'
					},
					{
						title:'Healthcare & Life Sciences Blog',
						img:require('../../assets/test/63.webp'),
						remarks:'Your go-to blog for healthcare and life sciences updates.'
					},
					{
						title:'AAM Insights',
						img:require('../../assets/test/64.jpeg'),
						remarks:'A resource for advanced air mobility stakeholders.'
					},{
						title:'Foreign Investment and National Security Blog',
						img:require('../../assets/test/65.webp'),
						remarks:'Keep up with news and updates on foreign investment review and national security trends and developments.'
					},
					{
						title:'Global Litigation News',
						img:require('../../assets/test/66.jpeg'),
						remarks:''
					},
					{
						title:'Global Supply Chain Compliance',
						img:require('../../assets/test/67.jpeg'),
						remarks:'With input from lawyers across our multidisciplinary teams, we bring you supply chain compliance insights from practitioners around the globe to offer our analysis of emerging legal trends and hot ...'
					},
					{
						title:'Middle East Insights',
						img:require('../../assets/test/55.webp'),
						remarks:'Knowledge, insight and perspective on doing business in the Middle East.'
					},
					{
						title:'Connect On Tech',
						img:require('../../assets/test/51.webp'),
						remarks:'Our latest global developments and podcast series covering data and technology, including data privacy and security, digital innovation, AI and more related to disruptive technology.'
					}
				]
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			goHome() {
				this.$router.replace('/');
			},
			toPage(path){
				this.$router.replace(path); 
			}
		}
	}
</script>

<style src="@/assets/main.css" scoped></style>
<style lang='scss' scoped>
	.body-container {
		width: 100%;
		/* min-width: 1280px; */
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}

	.main {
		padding-top: 82px;
	}
	.page-header-background-image.page-header-background-image-forced-height {
	    height: 6vh;
	}
	.background-image-desktop2 {
		background-image: url('../../assets/test/71.jpeg');
		background-size: 100% 100%;
	}
	@media screen and (max-width: 47.9375em){
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 20px;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.main {
			padding-top: 63px;
		}
		.promo-content-tile.promo-content-tile--has-image .promo-content-link .container-row {
		    margin: 0 20px;
		    padding: 15px;
		    bottom: -14px;
		    width: calc(87% - 40px);
		}
	}
</style>
